(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luckcoo-bundle-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const bind = () => document.querySelectorAll('[data-luckcoo-mix-color]').forEach(button => {
    if (button.dataset.initialized) return;
    const root = button.closest('[id^="PPHB-"]');
    const trigger = root?.querySelector('[data-pphb-option-drawer-open="' + button.dataset.luckcooMixColor + '"]');
    if (!trigger) return;
    button.dataset.initialized = 'true';
    button.hidden = false;
    button.addEventListener('click', () => trigger.click());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once: true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luckcoo-mix-match-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const dialog = document.querySelector('[data-luckcoo-mix-dialog]');
    if (!dialog || dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    document.body.append(dialog);
    const container = dialog.querySelector('[data-mix-products-container]');
    const status = dialog.querySelector('[data-mix-load-status]');
    const retry = dialog.querySelector('[data-mix-retry]');
    let trigger = null;
    let previousOverflow = '';
    let loading = false;
    const load = async () => {
      if (loading || container.dataset.loaded) return;
      const source = document.querySelector('[data-luckcoo-mix-source]');
      if (!source) { status.textContent = dialog.dataset.loadError; return; }
      loading = true;
      status.hidden = false;
      status.textContent = dialog.dataset.loading;
      retry.hidden = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', source.dataset.sectionId);
        const response = await fetch(url, {headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const result = doc.querySelector('template[data-luckcoo-mix-results]');
        if (!result) throw new Error();
        container.replaceChildren(result.content.cloneNode(true));
        container.dataset.loaded = 'true';
        status.hidden = true;
      } catch (error) {
        status.textContent = dialog.dataset.loadError;
        retry.hidden = false;
      } finally { loading = false; }
    };
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-luckcoo-mix-open]');
      if (!button) return;
      event.preventDefault();
      trigger = button;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.querySelector('[data-mix-close]').focus();
      load();
    });
    dialog.querySelector('[data-mix-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      if (trigger?.isConnected) trigger.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    retry.addEventListener('click', load);
    container.addEventListener('change', event => {
      const select = event.target.closest('[data-mix-variant]');
      if (!select) return;
      const card = select.closest('[data-mix-product]');
      const selected = select.selectedOptions[0];
      card.querySelector('[data-mix-price]').textContent = selected.dataset.price;
      const image = card.querySelector('img');
      if (image && selected.dataset.image) { image.removeAttribute('srcset'); image.src = selected.dataset.image; }
      card.querySelector('[data-mix-error]').hidden = true;
    });
    container.addEventListener('click', async event => {
      const button = event.target.closest('[data-mix-add]');
      if (!button || button.disabled || dialog.dataset.adding === 'true') return;
      const card = button.closest('[data-mix-product]');
      const select = card.querySelector('[data-mix-variant]');
      if (!select?.value || select.selectedOptions[0]?.disabled) return;
      const message = card.querySelector('[data-mix-error]');
      const label = button.textContent;
      const buttons = Array.from(container.querySelectorAll('[data-mix-add]'));
      dialog.dataset.adding = 'true';
      buttons.forEach(item => item.disabled = true);
      select.disabled = true;
      button.textContent = dialog.dataset.addingLabel;
      button.setAttribute('aria-busy','true');
      message.hidden = true;
      let accepted = false;
      let rejected = false;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:select.value,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})});
        const result = await response.json();
        if (!response.ok || result.status) { rejected = true; throw new Error(result.description || result.message || dialog.dataset.addError); }
        accepted = true;
        const cart = document.querySelector('cart-drawer');
        if (!cart || typeof cart.renderContents !== 'function' || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) throw new Error();
        cart.setActiveElement?.(trigger);
        dialog.close();
        cart.renderContents(result);
      } catch (error) {
        if (accepted) { window.location.assign(root+'cart'); return; }
        message.textContent = rejected ? error.message : dialog.dataset.addError;
        message.hidden = false;
      } finally {
        delete dialog.dataset.adding;
        buttons.forEach(item => item.disabled = false);
        select.disabled = false;
        button.textContent = label;
        button.removeAttribute('aria-busy');
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["luckcoo-product-image-help"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-luckcoo-image-help]');
  if (!config || config.dataset.initialized || typeof HTMLDialogElement === 'undefined') return;
  config.dataset.initialized = 'true';
  const dialog = config.querySelector('dialog');
  const stage = config.querySelector('.luckcoo-image-stage');
  const image = config.querySelector('[data-luckcoo-large-image]');
  const title = config.querySelector('h2');
  const closeButton = config.querySelector('[data-luckcoo-close]');
  const zoomIn = config.querySelector('[data-luckcoo-zoom-in]');
  const zoomOut = config.querySelector('[data-luckcoo-zoom-out]');
  let scale = 1;
  let returnTarget = null;
  let previousOverflow = '';
  const resizeImage = () => {
    if (!image.naturalWidth || !dialog.open) return;
    const ratio = image.naturalWidth / image.naturalHeight;
    const fitWidth = Math.min(image.naturalWidth, stage.clientWidth - 32, (stage.clientHeight - 32) * ratio);
    image.style.width = `${Math.max(1, fitWidth * scale)}px`;
    image.style.height = `${Math.max(1, fitWidth * scale / ratio)}px`;
    zoomIn.disabled = scale >= 4;
    zoomOut.disabled = scale <= 1;
  };
  const openImage = (src, alt, heading, trigger) => {
    returnTarget = trigger;
    scale = 1;
    title.textContent = heading;
    image.alt = alt || heading;
    image.removeAttribute('style');
    image.src = src;
    if (!dialog.open) {
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
    }
    stage.scrollTo(0, 0);
    resizeImage();
    closeButton.focus();
  };
  image.addEventListener('load', resizeImage);
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    image.removeAttribute('src');
    if (returnTarget?.isConnected) returnTarget.focus({preventScroll: true});
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  zoomIn.addEventListener('click', () => { scale = Math.min(4, scale + 1); resizeImage(); });
  zoomOut.addEventListener('click', () => { scale = Math.max(1, scale - 1); resizeImage(); });
  config.querySelector('[data-luckcoo-reset]').addEventListener('click', () => { scale = 1; resizeImage(); stage.scrollTo(0, 0); });
  window.addEventListener('resize', resizeImage);
  const bindImages = () => {
    document.querySelectorAll('.pphb-media__slide > img, .pds-content img, .pphb-desc img').forEach(img => {
      if (img.dataset.luckcooEnlarge || img.closest('a, button')) return;
      img.dataset.luckcooEnlarge = 'true';
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');
      img.setAttribute('aria-haspopup', 'dialog');
      img.setAttribute('aria-label', `${config.dataset.viewLabel}: ${img.alt}`);
      let down = null;
      img.addEventListener('pointerdown', event => { down = [event.clientX, event.clientY]; });
      const enlarge = () => {
        const url = new URL(img.currentSrc || img.src, location.href);
        if (url.hostname === 'cdn.shopify.com' || url.hostname === location.hostname) url.searchParams.set('width', '2400');
        openImage(url.href, img.alt, config.querySelector('h2').dataset.defaultTitle, img);
      };
      img.addEventListener('click', event => {
        if (down && Math.hypot(event.clientX - down[0], event.clientY - down[1]) > 10) { down = null; return; }
        down = null;
        enlarge();
      });
      img.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); down = null; enlarge(); }
      });
    });
    const helpTemplate = config.querySelector('[data-luckcoo-size-help]');
    if (helpTemplate) document.querySelectorAll('.pphb-option').forEach(group => {
      const legend = group.querySelector('legend');
      if (!legend || !/^size$/i.test(legend.textContent.trim()) || group.querySelector('.luckcoo-size-help')) return;
      legend.after(helpTemplate.content.cloneNode(true));
      group.querySelectorAll('[data-luckcoo-guide]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          openImage(link.href, link.dataset.guideTitle, link.dataset.guideTitle, link);
        });
      });
    });
  };
  title.dataset.defaultTitle = title.textContent;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindImages, {once: true});
  else bindImages();
  document.addEventListener('shopify:section:load', bindImages);
})();
  } catch(e) { console.error(e); }
})();

})();
